import React from "react";
import { Navigate } from "react-router-dom";
import PropTypes from "prop-types";
import authService from "../services/authService";
import { logger } from "../utils/logger";
const ProtectedRoute = ({ children, allowedRoles }) => {
  ProtectedRoute.propTypes = {
    children: PropTypes.node.isRequired,
    allowedRoles: PropTypes.string,
  };
  const isTherapist = authService.isTherapist();
  const isStaff = authService.isStaff();
  const isAuthenticated = authService.isAuthenticated();
  // Check role-based access
  if (allowedRoles) {
    const hasPermission =
      (allowedRoles === "therapist" && (isTherapist || isStaff)) ||
      (allowedRoles === "client" && (!isTherapist || isStaff)) ||
      (allowedRoles === "staff" && isStaff) ||
      (allowedRoles === "authenticated" && isAuthenticated);

    if (!hasPermission) {
      logger.info("Access denied!", {url: window.location.href});

      return <Navigate to={isTherapist ? "/clients" : "/programs"} replace />;
    }
  }

  return children;
};

export default ProtectedRoute;
